import {ActionBarBehavior} from "../action-bar-behavior";
import {Injectable, OnDestroy} from "@angular/core";
import {ActionBarConfig} from "../../../../model/action-bar-config";
import {ActionBarType} from "../../../../constants/action-bar-type.enum";
import {HttpCustomService} from "../../../../../service/http-custom.service";
import {API} from "../../../../apis/api";
import {HttpResponse} from "@angular/common/http";
import {DownloadFileUtil} from "../../../../utils/download-file.util";
import * as _ from "lodash";
import {NotificationService} from "../../../../service/notification.service";
import {NotificationType} from "../../../../constants/notification-type.enum";

@Injectable()
export class ExportMeterDataBehavior extends ActionBarBehavior implements OnDestroy {

  constructor(
    private http: HttpCustomService,
    private notification: NotificationService
  ) {
    super();
  }

  executeAction(actionBarConfig: ActionBarConfig, selectedRecords?: any[], additionalParams?: any) {
    const dataFilter = additionalParams.dataFilter;
    if (dataFilter) {
      if (!dataFilter.effectiveDate) {
        this.notification.open({
          type: NotificationType.WARNING,
          title: "Lưu ý",
          body: 'Hãy chọn ngày và bấm xem dữ liệu trước!'
        });
        return;
      }
      const params = _.pick(dataFilter, ['effectiveDate']);
      const stationNo = dataFilter.stationNo;
      this.http.post({
        path: API.STATION_METER_DATA_EXPORT,
        bind: {
          stationNo: {
            name: 'stationNo',
            placeholder: ':stationNo'
          }
        },
        values: {stationNo: stationNo}
      }, null, {params, responseType: 'blob', observe: 'response'})
        .subscribe((res: HttpResponse<Blob>) => {
          if (res) {
            DownloadFileUtil.download(res);
          }
        })
    } else {
      this.notification.open({
        type: NotificationType.WARNING,
        title: "Lưu ý",
        body: 'Hãy chọn ngày và bấm xem dữ liệu trước!'
      });
    }
  }

  isActionBar(type: ActionBarType): boolean {
    return ActionBarType.DOWNLOAD === type;
  }

  ngOnDestroy(): void {
  }
}
